var Quill = require( 'quill' );
var BlockEmbed = Quill.import( 'blots/block/embed' );

class ExplodedProductCard extends BlockEmbed {
    static create( paramValue ) {
        let node = super.create();

        if( typeof paramValue === 'object' ) {
            node.setAttribute( 'data-product-id', paramValue.dataId );
            node.setAttribute( 'data-product-title', paramValue.dataTitle );
            let innerSpan = document.createElement('span');
            node.appendChild( innerSpan );
        }
        else if( typeof paramValue === 'string' ) {
            node.innerHTML = paramValue;
        }
        //node.addEventListener('click', ExplodedProductCard.onClick);
        return node;
    }

    static formats( node ) {
        return node.getAttribute( 'data-product-id' );
    }

    static value( node ) {
        return {
            'dataId': node.getAttribute( 'data-product-id' ),
            'dataTitle': node.getAttribute( 'data-product-title' ),
        };
    }
}

ExplodedProductCard.blotName = 'exploded-product-card';
ExplodedProductCard.className = 'exploded-product-card--placeholder';
ExplodedProductCard.tagName = 'DIV';
//in case you need to inject an event from outside
/* ExplodedProductCard.onClick = function(){
     //do something
 }*/

export default ExplodedProductCard;
